// extracted by mini-css-extract-plugin
export default {"container":"RoundImage_container__1mFPK","normal":"RoundImage_normal__54gEO","small":"RoundImage_small__uEE90"};